module.exports = __webpack_public_path__ + "img/sciencefigures.e0bd4ac7.jpg";